import { render, staticRenderFns } from "./Item5Detail2.vue?vue&type=template&id=65c30f07"
import script from "./Item5Detail2.vue?vue&type=script&lang=js"
export * from "./Item5Detail2.vue?vue&type=script&lang=js"
import style0 from "./Item5Detail2.vue?vue&type=style&index=0&id=65c30f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports